<template>
  <v-container>
    <toolbar mode="dataset" title="Compile" view="list" />
    <dataset ref="dataset" @submitted="onSubmit"></dataset>
  </v-container>
</template>

<script>
import toolbar from '@/components/toolbar'
import dataset from '@/components/Forms/Dataset'
import Datasets from '@/api/datasets'
export default {
  name: "CompileDataset",
  components: { 
    toolbar,
    dataset
  },
  methods: {
    onSubmit(dataset) {
      Datasets.create({
        name: dataset.name,
        completion: dataset.completion,
        production: dataset.production,
        economic: dataset.economic,
        identifier: dataset.identifier,
        filters: dataset.filters,
        owner: this.user.id,
      }).then(_ => {
        this.$router.push({ name: "datasetList" })
      })
    }
  }
}
</script>
